import { EERIE, OBSIDIAN } from 'HubStyleTokens/colors';
import InitialMessageTextButton from './components/InitialMessageTextButton';
import I18n from 'I18n';
import styled from 'styled-components';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import { createThemeV2 } from 'visitor-ui-component-library/theme/createThemeV2';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGClose from 'visitor-ui-component-library-icons/icons/SVGClose';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import InitialMessageAvatars from './components/InitialMessageAvatars';
import { AVATAR_SIZES } from 'visitor-ui-component-library/avatar/constants/AvatarSizes';
import { SMALL, MEDIUM } from 'visitor-ui-component-library/constants/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getAvatarHeightAboveBubble = mobile => {
  const avatarHeightPx = mobile ? AVATAR_SIZES[SMALL] : AVATAR_SIZES[MEDIUM];
  return avatarHeightPx / 2;
};
export const CloseButton = styled(VizExIconButton).withConfig({
  displayName: "CommonWelcomeMessageContent__CloseButton",
  componentId: "sc-1kh6n92-0"
})(["position:absolute;top:0;right:0;width:36px;height:36px;color:", ";z-index:2;&:focus-visible{outline-offset:-2px;}"], EERIE);
export const CommonWelcomeMessageContent = ({
  onClick,
  initialMessage,
  onClose,
  chatHeadingConfig,
  chatHeadingResponders,
  mobile
}) => {
  const renderCloseButton = () => {
    return /*#__PURE__*/_jsx(CloseButton, {
      "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.dismiss'),
      size: "md",
      use: "transparent-on-background",
      shape: "circle",
      theme: createThemeV2({
        colors: {
          primary: OBSIDIAN
        }
      }),
      "data-test-id": "initial-message-close-button",
      onClick: onClose,
      children: /*#__PURE__*/_jsx(VizExIcon, {
        size: "13px",
        icon: /*#__PURE__*/_jsx(SVGClose, {})
      })
    });
  };
  const renderAvatar = () => {
    const avatarHeightPx = mobile ? AVATAR_SIZES.sm : AVATAR_SIZES.md;
    const top = -(getAvatarHeightAboveBubble(mobile) || avatarHeightPx / 2);
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "initial-message-avatar-wrapper",
      className: "initial-message-avatar justify-center",
      onClick: onClick,
      style: {
        top
      },
      children: /*#__PURE__*/_jsx(InitialMessageAvatars, {
        chatHeadingConfig: chatHeadingConfig,
        chatHeadingResponders: chatHeadingResponders,
        mobile: mobile
      })
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(InitialMessageTextButton, {
      onPress: onClick,
      children: [renderAvatar(), /*#__PURE__*/_jsx("p", {
        id: "welcome-message",
        role: "status",
        "data-test-id": "initial-message-text",
        className: "initial-message-text m-top-1 m-bottom-0",
        onClick: onClick
        /* eslint-disable-next-line react/no-danger */,
        dangerouslySetInnerHTML: {
          __html: formatHtml(initialMessage)
        }
      })]
    }), renderCloseButton()]
  });
};
CommonWelcomeMessageContent.displayName = 'CommonWelcomeMessageContent';
export default CommonWelcomeMessageContent;